document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-lux-contact]');
  if (!root) return;

  root.querySelectorAll('[data-lux-faq-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.closest('.lux-contact-faq-item')?.classList.toggle('is-open');
    });
  });

  root.querySelectorAll('.lux-contact-tag').forEach((tag) => {
    tag.addEventListener('click', () => {
      const search = root.querySelector('.lux-contact-search__input');
      if (search) {
        search.value = tag.textContent.trim();
        search.focus();
      }
    });
  });

  const searchForm = root.querySelector('[data-lux-contact-search]');
  if (searchForm) {
    searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const q = searchForm.querySelector('input')?.value.trim();
      if (q) window.location.href = `/search?q=${encodeURIComponent(q)}&type=page,article`;
    });
  }

  const scrollToContactForm = () => {
    const card = root.querySelector('#lux-contact-form-card');
    const form = root.querySelector('[data-lux-contact-form]');
    const target = card || form;
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const firstInput = form?.querySelector('input:not([type="hidden"])');
    if (firstInput) window.setTimeout(() => firstInput.focus({ preventScroll: true }), 450);
  };

  root.querySelectorAll('[data-lux-scroll-form]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      scrollToContactForm();
    });
  });

  const contactForm = root.querySelector('[data-lux-contact-form]');
  if (contactForm) {
    contactForm.addEventListener('submit', () => {
      const first = contactForm.querySelector('[name="lux_first_name"]')?.value.trim() || '';
      const last = contactForm.querySelector('[name="lux_last_name"]')?.value.trim() || '';
      const topic = contactForm.querySelector('[name="lux_topic"]')?.value || '';
      const order = contactForm.querySelector('[name="lux_order"]')?.value.trim() || '';
      const message = contactForm.querySelector('[name="contact[body]"]')?.value.trim() || '';

      const nameField = contactForm.querySelector('[name="contact[name]"]');
      if (nameField) nameField.value = [first, last].filter(Boolean).join(' ');

      const bodyField = contactForm.querySelector('[name="contact[body]"]');
      if (bodyField) {
        const parts = [];
        if (topic && topic !== 'Select a topic…') parts.push(`Topic: ${topic}`);
        if (order) parts.push(`Order: ${order}`);
        if (message) parts.push('', message);
        bodyField.value = parts.join('\n');
      }
    });
  }

  const header = document.querySelector('[data-lux-site-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
});
